import { render, staticRenderFns } from "./totalStudy.vue?vue&type=template&id=59f66ddb"
import script from "./totalStudy.vue?vue&type=script&lang=js"
export * from "./totalStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports